import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import PublicFooter from "./components/PublicFooter";
import AppErrorBoundary from "./components/AppErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicOnlyRoute from "./components/PublicOnlyRoute";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./Landingpage";
import Admin from "./pages/Admin";
import Billing from "./pages/Billing";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Pricing from "./pages/Pricing";
import Team from "./pages/Team";
import Privacy from "./Privacy";
import Terms from "./Terms";
import Track from "./Track";
import AccountDeletion from "./AccountDeletion";

function App() {
  return (
    <AuthProvider>
      <AppErrorBoundary>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/login"
              element={(
                <PublicOnlyRoute>
                  <Login />
                </PublicOnlyRoute>
              )}
            />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/account-deletion" element={<AccountDeletion />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/t/:slug" element={<Track />} />
            <Route
              path="/billing"
              element={(
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/admin"
              element={(
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/team"
              element={(
                <ProtectedRoute>
                  <Team />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/dashboard"
              element={(
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              )}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PublicFooter />
        </BrowserRouter>
      </AppErrorBoundary>
    </AuthProvider>
  );
}

export default App;
